

const Calendar = {
	
	url: {
		prepare: url => {
			// Replace https:// with webcal://
			return encodeURI( url.replace( 'https://', 'webcal://' ) );
		},
		
		default: ( url ) => {
			return Calendar.url.prepare( url );
		},
		
		google: ( url ) => {
			return `https://www.google.com/calendar/render?cid=${ Calendar.url.prepare( url ) }`;
		},
		
		outlook: ( url ) => {
			return `https://outlook.office.com/owa?path=%2Fcalendar%2Faction%2Fcompose&rru=addsubscription&url=${ Calendar.url.prepare( url ) }&name=My%20Office%20Days`;
		}
	}
}

export default Calendar;
